import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import type { AppDispatch } from "../../../store";
import { fetchUserInfo, fetchAllPermittedCustomers } from "../../../redux/services/customerService";
import { handleAuthorizationCode, clearCookie } from "../../../utils/common";
import { isEmpty } from "lodash";

export const useAuthHandler = (permittedCustomers: any[]) => {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>();
    const [authorizationHandled, setAuthorizationHandled] = useState<boolean>(false);
    const [loginStatus, setLoginStatus] = useState<string>("");
    const [authLoading, setAuthLoading] = useState<boolean>(true);

    const callUserApi = () => {
        setAuthLoading(false);
        dispatch(fetchUserInfo());
        isEmpty(permittedCustomers) && dispatch(fetchAllPermittedCustomers());
        
        // If user is already logged in and there's an intended URL, redirect to it
        const intendedUrl = localStorage.getItem('intendedUrl');
        if (intendedUrl && !window.location.pathname.includes('code=')) {
            localStorage.removeItem('intendedUrl');
            navigate(intendedUrl);
        }
    };

    useEffect(() => {
        const code = new URLSearchParams(location.search).get("code");
        if (localStorage.getItem("user") === "true") {
            callUserApi();
        } else if (code && !authorizationHandled) {
            setAuthorizationHandled(true);
            handleAuthorizationCode(code, setAuthLoading, setLoginStatus, navigate);
        } else {
            clearCookie();
        }
    }, [location.search]);

    return { authLoading, loginStatus, setLoginStatus, callUserApi };
};